import { clsx } from "clsx";
import type { CSSProperties, ReactNode } from "react";

const paddingClass = {
  md: "p-6",
} as const;

export type CardProps = {
  tone?: "default" | "tonal";
  padding?: keyof typeof paddingClass;
  className?: string;
  // For the rare case a card needs a one-off background/text colour (e.g.
  // borrowing a REGION_COLORS pairing) rather than the tone presets above.
  style?: CSSProperties;
  children?: ReactNode;
};

export function Card({ tone = "default", padding, className, style, children }: CardProps) {
  return (
    <div
      className={clsx(
        "rounded-[var(--radius-lg)] border border-border shadow-[var(--shadow-sm)] transition-shadow",
        "hover:shadow-[var(--shadow-md)]",
        tone === "tonal" ? "bg-surface" : "bg-surface-muted",
        padding && paddingClass[padding],
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}
